import './App.css';
import {Grid} from "@mui/material";
import Pagina from "./Pagina/Pagina";
import '@fontsource/poppins/300.css';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/800.css';
import '@fontsource/poppins/900.css';
import '@fontsource/bellefair/400.css';
import {useObtenerDataActualizada} from "./Modulo_Optimizacion_Data/Hooks/useObtenerDataActualizada";
import {createContext, useEffect} from "react";
import {obtenerFechaAct} from "./Servicios/BD/Actualizadores/obtenerFechaAct";

export const contexApp = createContext()

function App() {
    const {data: adicionales, actualizarDataLocal: actAdicionales} = useObtenerDataActualizada({clave: 'adicionales'})

    const valoresProvider = {
        adicionales
    }

    const {Provider} = contexApp;

    useEffect(() => {
        obtenerFechaAct('adicionales').then((dox) => {
            let w = []
            actAdicionales({fecha: dox, wheres: w}).then()
        })
    }, [])
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Provider value={valoresProvider}>
                <Pagina/>
            </Provider>


        </Grid>
    );
}

export default App;
